export default "__VITE_ASSET__Bf7ah1XA__"